module.exports = __webpack_public_path__ + "img/smartDaily.f68c2300.svg";